import { request } from '@/shared/api/request'

export const getContractTerms = (params) => {
	return request({ url: `dict/contractDate?shortlist=${params}`, method: 'GET' })
}
